<template>
  <div id="wrapper">
    <div id="over_map">
      <b-button variant="primary" v-b-toggle.sidebar-1>Statistics</b-button>
    </div>

    <div id="map">
      <mapbox :coordinates="this.coordinates" />
    </div>
    <b-sidebar id="sidebar-1" style="text-align: center" shadow>
      <div class="px-3 py-2">
        <h1>Statistics</h1>
        <hr />
        <img alt="App logo" src="../assets/logo.png" height="64px" width="64px" />
        <br>
        <h5>{{mensagemAtividadeAdecorrer}}</h5>
        <br />
        <br />
        <div class="row">
          <div class="col-6">
            <h5>Elapsed Time</h5>
            <p>{{mensagemTempo}}</p>
          </div>
          <div class="col-6">
            <h5>Type of Activity</h5>
            <p>{{mensagemTipo}}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-6">
            <h5>Current Velocity</h5>
            <p>{{mensagemVelocidade}}</p>
          </div>
          <div class="col-6">
            <h5>Travelled Distance</h5>
            <p>{{mensagemDistancia}}</p>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-6">
            <h5>Altitude</h5>
            <p>{{mensagemAltitude}}</p>
          </div>
          <div class="col-6"></div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import firebase from "firebase";
import Mapbox from "./Mapbox.vue";
export default {
  name: "TrackUser",
  components: {
    Mapbox
  },
  props: {
    uuid: String
  },
  data() {
    return {
      user: "",
      mensagemTempo: "00:00:00",
      mensagemTipo: "Running",
      mensagemVelocidade: "4:20 m/km",
      mensagemAltitude: "120 meters",
      mensagemDistancia: "4.82 km",
      mensagemAtividadeAdecorrer: "The activity is paused",
      coordinates: [-73.935242, 40.73061]
    };
  },
  beforeMount() {
    let rootRef = firebase.database().ref();
    let query = rootRef.child("users").child(this.uuid);
    query.once("value", snapshot => {
      this.user = snapshot.val();
    });
  },
  created() {
    //Logica para meter listener para dar reload das variaveis
    let rootRef = firebase.database().ref();
    let query = rootRef.child("users").child(this.uuid);
    query.on("child_changed", () => {
      let query1 = rootRef.child("users").child(this.uuid);
      query1.once("value", snapshot => {
        this.user = snapshot.val();
        console.log(snapshot.key);
        this.reloadDados();
      });
    });
    query.on("child_added", () => {
      let query1 = rootRef.child("users").child(this.uuid);
      query1.once("value", snapshot => {
        this.user = snapshot.val();
        console.log(snapshot.key);
        this.reloadDados();
      });
    });
    query.on("child_removed", () => {
      let query1 = rootRef.child("users").child(this.uuid);
      query1.once("value", snapshot => {
        this.user = snapshot.val();
        console.log(snapshot.key);
        this.reloadDados();
      });
    });
  },
  methods: {
    reloadDados() {
      //ver se o user terminou a atividade para sair deste ecra
      if (this.user.activity_running === false) {
        //mostra pop up a dizer que acabou o track e sai desta janela para  a principal
        this.$router.push({
          name: "search"
        });
        this.$bvModal.show("terminado");
        return;
      }

      if (
        "activity_paused" in this.user &&
        this.user.activity_paused === true
      ) {
        this.mensagemAtividadeAdecorrer = "The activity is paused";
      } else {
        this.mensagemAtividadeAdecorrer = "The activity is running";
      }

      let long = this.user.activity_data.location.split(" ")[1];
      let lat = this.user.activity_data.location.split(" ")[0];
      this.coordinates = [long, lat];
      this.mensagemTempo = this.user.activity_data.elapsed_time;
      this.mensagemTipo = this.user.activity_data.type_activity;
      this.mensagemVelocidade = this.user.activity_data.speed;
      this.mensagemAltitude = this.user.activity_data.altitude;
      this.mensagemDistancia = this.user.activity_data.travelled_distance;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
body.modal-open {
  overflow: hidden;
  height: 100vh;
}

#wrapper {
  position: relative;
}
#over_map {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 99;
}
.center-block {
  margin: 0 auto; /*It will center the block*/
  float: none;
  text-align: center; /*It will center the content inside block*/
}

#map {
  width: 100%;
  height: 100vh;
}
</style>
